/**
 * Product name blacklist shared across code that needs to skip non-"real" line
 * items — package protection, gift cards, return labels, store credit, and
 * similar Redo/merchant-internal products.
 *
 * Matched by lowercase substring against product title and variant title.
 */
export const PRODUCT_NAMES_BLACKLIST = [
  "gift card",
  "shipping protection",
  "package protection",
  "order protection",
  "battle beaver build time",
  "store credit",
  "free shipping",
  "delivery is free",
  "free return",
  "free accessory",
  "shipping for sole premise",
  "delivery guarantee",
  "third party insurance",
  "checkout+",
  "extend protection plan",
  "sample bag (free with coupon code freebrittle)",
];

export function isBlacklistedProductName(
  title: string | null | undefined,
  variantTitle?: string | null | undefined,
): boolean {
  const t = (title ?? "").toLowerCase();
  const v = (variantTitle ?? "").toLowerCase();
  return PRODUCT_NAMES_BLACKLIST.some(
    (blacklisted) => t.includes(blacklisted) || v.includes(blacklisted),
  );
}
